document.addEventListener('alpine:init', () => {
  Alpine.store('nav', {
    currentIndex: null,
    setCurrentIndex(index) {
      this.currentIndex = index;
    }
  });

  Alpine.store('modals', {
    rightDrawer: {
      contents: null
    },
    open(modal) {
      this.rightDrawer.contents = modal;
    },
    close(modal) {
      if (this.rightDrawer.contents === modal) {
        this.rightDrawer.contents = null;
        Alpine.store('nav').currentIndex = null; // Reset index when closing
      }
    }
  });
});